/* Local visual storefront: search stays on this device; newsletter never sends or stores email. */
(() => {
  'use strict';
  const $ = (selector, root = document) => root.querySelector(selector);
  const params = new URLSearchParams(location.search);
  const reviewing = (PC.local || PC.preview) && params.get('uiPreview') === '1';
  let quiet = reviewing && params.has('quiet') ? params.get('quiet') === '1' : params.get('quiet') === '1' || document.body.dataset.quiet === 'true';
  try { if (!(reviewing && params.has('quiet'))) quiet ||= ['true','1'].includes(localStorage.getItem('paw-preview-quiet')); } catch {}
  const site = new URL('.', location.href);
  const route = (href, gentle = false) => {
    const url = new URL(href, site);
    if (quiet || gentle) url.searchParams.set('quiet', '1');
    return url.href;
  };
  const element = (tag, text, className) => {
    const node = document.createElement(tag);
    if (text) node.textContent = text;
    if (className) node.className = className;
    return node;
  };
  const arrow = () => { const node = element('span', '→'); node.setAttribute('aria-hidden', 'true'); return node; };

  // Retire the old page-specific search nodes and their listeners after page setup.
  // This leaves the existing menu, cart and product handlers intact.
  $('#search')?.remove();
  const search = element('dialog', null, 'site-search');
  search.id = 'site-search';
  search.setAttribute('aria-labelledby', 'site-search-title');
  search.innerHTML = `<div class="site-search-top"><div class="site-search-heading"><h2 id="site-search-title">Find what you need.</h2><button type="button" class="site-search-close" aria-label="Close search">×</button></div><form class="site-search-form" role="search"><label class="site-visually-hidden" for="site-query">Search products, help and stories</label><div class="site-query-row"><svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="10" cy="10" r="6.5"/><path d="m15 15 6 6"/></svg><input id="site-query" type="search" placeholder="Products, help, stories…" autocomplete="off" maxlength="160"><button type="button" class="site-clear" hidden>Clear</button></div></form></div><div class="site-search-content"><p class="site-result-count" role="status" aria-live="polite"></p><div class="site-search-results"></div></div>`;
  document.body.append(search);
  const query = $('#site-query'), results = $('.site-search-results', search), count = $('.site-result-count', search);
  let searchState = 'initial', showAll = false, searchOpener = null, previousScroll = 0;
  const index = Array.isArray(window.PAW_SITE_SEARCH) ? window.PAW_SITE_SEARCH : null;
  const normalize = value => String(value).normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^\p{L}\p{N}]+/gu,' ').trim();
  const announcePreview = () => {
    const detail = { type: 'paw-site-preview', message: '邮箱格式已通过；当前没有提交或发送。可在上方切换反馈状态。' };
    if (parent !== window) parent.postMessage(detail, location.origin);
  };
  function helpLink() { const a = element('a', 'Ask us a question', 'site-help-link'); a.href = route('/pages/contact'); return a; }
  function suggestions() {
    const group = element('div', null, 'site-suggestions');
    [['Photos','photos'], ['Shipping','shipping'], ['The making','making']].forEach(([label, value]) => {
      const button = element('button', label); button.type = 'button';
      button.addEventListener('click', () => { query.value = value; searchState = 'results'; showAll = false; renderSearch(); query.focus(); });
      group.append(button);
    });
    return group;
  }
  function renderSearch() {
    results.replaceChildren(); count.textContent = ''; results.removeAttribute('aria-busy');
    $('.site-clear', search).hidden = !query.value;
    if (history.state?.pawSiteSearch) history.replaceState({...history.state, pawSiteQuery: query.value}, '', location.href);
    if (searchState === 'loading') {
      results.setAttribute('aria-busy', 'true');
      const row = element('div', null, 'site-loading'), spinner = element('span', null, 'site-spinner'); spinner.setAttribute('aria-hidden','true');
      row.append(spinner, element('p', 'Searching…')); results.append(row); count.textContent = 'Searching'; return;
    }
    if (searchState === 'error' || !index) {
      const box = element('div', null, 'site-empty'); box.append(element('h3', 'We couldn’t load the results.'), element('p', 'Please try again.'));
      const retry = element('button', 'Try again', 'site-action'); retry.type = 'button';
      retry.addEventListener('click', () => { if (!index) location.reload(); else {searchState = 'results'; renderSearch();} });
      box.append(retry, helpLink()); results.append(box); return;
    }
    const words = normalize(query.value).split(' ').filter(Boolean).map(word => word.length > 4 && word.endsWith('s') ? word.slice(0,-1) : word);
    if (!words.length) { count.textContent = 'A few places to start'; results.append(suggestions(), helpLink()); return; }
    const rank = item => words.filter(word => normalize(item.title).includes(word)).length * 10 + (normalize(item.title) === normalize(query.value) ? 100 : 0);
    const found = index.filter(item => words.every(word => normalize(item.title+' '+item.terms).includes(word))).sort((a,b) => rank(b)-rank(a));
    count.textContent = `${found.length} ${found.length === 1 ? 'result' : 'results'}`;
    if (!found.length) {
      const box = element('div', null, 'site-empty'); box.append(element('h3', `No matches for “${query.value.trim()}”.`), element('p', 'Try a different word, or ask us a question.'), suggestions(), helpLink()); results.append(box); return;
    }
    const titles = found.filter(item => rank(item) > 0), shortlist = !showAll && titles.length ? titles : found;
    let displayed = 0;
    ['Products', 'Help & guides', 'Stories'].forEach(group => {
      const matched = shortlist.filter(item => item.group === group); if (!matched.length) return;
      const section = element('section', null, 'site-result-group'); section.append(element('h3', group));
      (showAll ? matched : matched.slice(0,2)).forEach(item => {
        const a = element('a', null, 'site-result-link'); a.href = route(item.href,item.quiet); a.append(element('span', item.title),arrow()); section.append(a); displayed++;
      }); results.append(section);
    });
    if (displayed < found.length) {
      const more = element('button', `Show all ${found.length} results`, 'site-text-button'); more.type = 'button';
      more.addEventListener('click', () => { showAll = true; renderSearch(); results.querySelector('a')?.focus({preventScroll:true}); }); results.append(more);
    }
  }
  function lockSearch() { previousScroll = scrollY; document.body.classList.add('site-search-is-open'); }
  function openSearch(opener, push = true) {
    if (search.open) return;
    searchOpener = opener || $('[data-site-search]');
    // Keep product selection and FAQ navigation state in the same history entry.
    if (push) history.pushState({...history.state, pawSiteSearch:true, pawSiteQuery:query.value}, '', location.href);
    lockSearch(); search.showModal(); renderSearch(); query.focus();
  }
  function closeSearch() { if (history.state?.pawSiteSearch) history.back(); else search.close(); }
  document.querySelectorAll('[data-dialog="search"]').forEach(old => {
    const button = old.cloneNode(true); button.removeAttribute('data-dialog'); button.dataset.siteSearch = ''; button.setAttribute('aria-haspopup','dialog'); button.setAttribute('aria-controls','site-search');
    old.replaceWith(button); button.addEventListener('click', () => openSearch(button));
  });
  $('.site-search-close', search).addEventListener('click', closeSearch);
  search.addEventListener('cancel', event => {event.preventDefault(); closeSearch();});
  search.addEventListener('keydown', event => { if (event.key === 'Escape') {event.preventDefault();event.stopPropagation();closeSearch();} });
  search.addEventListener('close', () => {document.body.classList.remove('site-search-is-open');window.scrollTo({top:previousScroll,behavior:'instant'});searchOpener?.focus({preventScroll:true});});
  search.addEventListener('click', event => {if(event.target!==search)return;const r=search.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)closeSearch();});
  addEventListener('popstate', () => {
    if (history.state?.pawSiteSearch) { query.value=history.state.pawSiteQuery||''; if(!search.open)openSearch(searchOpener,false); }
    else if(search.open)search.close();
  });
  query.addEventListener('input', () => {searchState='results';showAll=false;renderSearch();});
  $('.site-search-form',search).addEventListener('submit', event => {event.preventDefault();searchState='results';showAll=false;renderSearch();});
  $('.site-clear',search).addEventListener('click', () => {query.value='';searchState='initial';showAll=false;renderSearch();query.focus();});
  // Close before same-page destination handlers (FAQ and section links) run.
  search.addEventListener('click', event => {
    const a = event.target.closest('a'); if(!a || event.button!==0 || event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;
    const target = new URL(a.href);
    if(target.pathname===location.pathname && target.origin===location.origin){
      history.replaceState({...history.state,pawSiteSearch:false},'',location.href);search.close();
    }
  },true);

  const forms = [];
  let returnedFormId = '';
  try { returnedFormId = decodeURIComponent(location.hash.slice(1)); } catch {}
  document.querySelectorAll('[data-newsletter]').forEach((old, n) => {
    const originalEmail = $('input[type=email]', old)?.value || '';
    const serverResponse = old.id === returnedFormId ? old.querySelector('[data-pc-server-feedback]')?.cloneNode(true) : null;
    const platformFields = [...old.querySelectorAll('input[type=hidden]')].map(n=>n.outerHTML).join('');
    const form = old.cloneNode(false); form.classList.add('site-signup'); form.noValidate=true; old.replaceWith(form);
    const id = `site-email-${n}`;
    form.innerHTML = `<div class="site-signup-fields"><label for="${id}">Your email</label><div class="site-email-row"><input id="${id}" type="email" name="contact[email]" placeholder="you@example.com" maxlength="254" autocomplete="off" required aria-describedby="${id}-message ${id}-consent"><button type="submit" class="button site-subscribe">Subscribe <span aria-hidden="true">→</span></button></div><p class="site-field-message" id="${id}-message" aria-live="polite"></p><p class="site-consent" id="${id}-consent">By subscribing, you agree to receive marketing emails. Unsubscribe anytime. <a href="${route('/pages/privacy-policy')}">Privacy policy</a></p></div><div class="site-received" hidden tabindex="-1"><span class="site-confirm-icon" aria-hidden="true">✓</span><h3>Thanks.</h3><p>Check your inbox for any next steps.</p><button type="button" class="site-text-button site-change-email">Use a different email</button></div>`;
    if (serverResponse) form.append(serverResponse);
    form.insertAdjacentHTML('afterbegin',platformFields);
    const input=$('input[type=email]',form), fields=$('.site-signup-fields',form),received=$('.site-received',form),message=$('.site-field-message',form),submit=$('[type=submit]',form);
    function setState(state, focus=false) {
      const accepted=['received','existing'].includes(state);fields.hidden=accepted;received.hidden=!accepted;
      form.removeAttribute('aria-busy'); input.readOnly=false;input.removeAttribute('aria-invalid');submit.disabled=false;submit.replaceChildren(document.createTextNode('Subscribe '),arrow());message.textContent='';message.className='site-field-message';
      if(state==='invalid'){input.setAttribute('aria-invalid','true');message.textContent='Please enter a valid email address.';}
      if(state==='loading'){form.setAttribute('aria-busy','true');input.readOnly=true;submit.disabled=true;submit.textContent='Submitting…';message.classList.add('is-pending');message.textContent='Submitting your request…';}
      if(state==='error'){message.textContent='We couldn’t confirm your request. Please try again.';submit.replaceChildren(document.createTextNode('Try again '),arrow());}
      if(focus)(accepted?received:input).focus({preventScroll:true});
    }
    input.addEventListener('input',()=>{input.removeAttribute('aria-invalid');message.textContent='';});
    form.addEventListener('submit',event=>{
      if(!quiet && !PC.local && !PC.preview && input.validity.valid){input.value=input.value.trim();return;}
      event.preventDefault();if(quiet)return;
      input.value=input.value.trim();if(!input.validity.valid){setState('invalid',true);return;}
      setState('form');
      // A functioning form must await the real service. No simulated success timer.
      message.classList.add('is-preview');message.textContent='Preview only — no email has been submitted.';announcePreview();
    });
    $('.site-change-email',form).addEventListener('click',()=>{input.value='';setState('form',true);});
    let feedback = null;
    if (serverResponse?.getAttribute('role') === 'status') {
      setState('received');
      $('p',received).textContent = serverResponse.textContent;
      serverResponse.hidden = true;
      feedback = received;
    } else if (serverResponse?.getAttribute('role') === 'alert') {
      input.value = originalEmail;
      serverResponse.tabIndex = -1;
      submit.replaceChildren(document.createTextNode('Try again '),arrow());
      feedback = serverResponse;
    }
    forms.push({form,input,setState,feedback});
  });
  const signupDialog=$('#newsletter-dialog');
  if(signupDialog){
    $('h2',signupDialog).textContent='$10 off your first order.';
    signupDialog.querySelector(':scope > p').textContent='Studio updates, new designs and occasional offers.';
    signupDialog.addEventListener('close',()=>forms.filter(x=>signupDialog.contains(x.form)&&!x.feedback).forEach(x=>{x.input.value='';x.setState('form');}));
  }
  if(quiet){
    document.querySelectorAll('.marketing,[data-marketing],[data-dialog="newsletter-dialog"],a[href*="facebook.com/groups/"],a[href*="#stay-close"]').forEach(node=>node.hidden=true);
    signupDialog?.close();
  }
  // Shopify can return the same customer-form result in several form blocks.
  // Only restore the submitted surface, using its native return fragment.
  if (!quiet) {
    const returned = forms.find(x=>x.feedback && x.form.id === returnedFormId);
    if (returned) {
      if (signupDialog?.contains(returned.form) && !signupDialog.open) signupDialog.showModal();
      requestAnimationFrame(()=>returned.feedback.focus({preventScroll:true}));
    }
  }
  if(document.body.classList.contains('aux404')){
    document.querySelectorAll('a[href]').forEach(a=>{if(!a.getAttribute('href').startsWith('#'))a.href=route(a.getAttribute('href'));});
    const menu=$('#menu'), opener=$('[data-dialog="menu"]');
    opener?.addEventListener('click',()=>menu.showModal());
    menu?.querySelector('.close-dialog')?.addEventListener('click',()=>menu.close());
    menu?.addEventListener('close',()=>opener.focus({preventScroll:true}));
  }
  function review({component,state='form',surface='inline'}={}) {
    if(!reviewing)return;
    if(component==='search'){
      searchState=state;showAll=false;query.value=state==='empty'?'unicorn':state==='initial'?'':'photos';
      if(!search.open)openSearch();else renderSearch();
    } else if(component==='newsletter'&&!quiet) {
      const choice=forms.find(item=>surface==='dialog'?signupDialog?.contains(item.form):!signupDialog?.contains(item.form));
      if(!choice)return;
      if(surface==='dialog'){if(!signupDialog.open)signupDialog.showModal();}
      else {signupDialog?.close();(choice.form.closest('.newsletter-panel')||choice.form).scrollIntoView({behavior:'instant',block:'start'});}
      choice.input.value=state==='invalid'?'pet-parent':['loading','error'].includes(state)?'you@example.com':'';
      choice.setState(state);
    }
  }
  window.PawSiteUI={review};
  if(history.state?.pawSiteSearch){query.value=history.state.pawSiteQuery||'';openSearch(null,false);}
  if(reviewing)requestAnimationFrame(()=>review({component:params.get('ui'),state:params.get('state')||'form',surface:params.get('surface')||'inline'}));
})();
